import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useActorTableChangeVersion } from "@-/dev.improve.haniverse.lib.database.change.actor";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { DECK_STUDY_CARD_QUERY_CONFIG } from "#deck-study-card-query-config";

const STUDYING_DECK_STUDY_CARDS_CONFIG = {
  ...DECK_STUDY_CARD_QUERY_CONFIG,
  where: {
    OR: [
      { startedStudyingAt: { isNotNull: true } } as const,
      { manuallyMasteredAt: { isNotNull: true } } as const,
    ],
  },
};

export function useGetStudyingDeckStudyCardsQueryKey() {
  const [db] = useContextSelectors(ActorDatabaseContext, (context) => context.db);
  const withTableChangeVersion = useActorTableChangeVersion(
    "userCard",
    STUDYING_DECK_STUDY_CARDS_CONFIG,
  );
  return () => withTableChangeVersion(["studyingDeckStudyCards", { db }] as const);
}

export const [useStudyingDeckStudyCardsQueryOptions, studyingDeckStudyCardsQueryFn] =
  createUseQueryOptions(useGetStudyingDeckStudyCardsQueryKey, async ({ queryKey: [_, { db }] }) => {
    return db(import.meta.location).query.userCard.findMany(STUDYING_DECK_STUDY_CARDS_CONFIG);
  });
